
export const INLNK = `
  fragment BA on BlogArticlePage {
    url
  }
  fragment BC on BlogCategoryPage {
    url
  }
  fragment CH on PageContentHub {
    url
  }
  
  fragment CSAR on PageTemplateCareerServicesAssessmentResults {
    url
  }
  fragment FL on FacultyListing {
    url
  }
  fragment PMER on PageMilitaryEstimatorResults {
    url
  }
  fragment OC on OptimizedCombo {
    url
  }
  fragment PDP on Pdp {
    url
  }
  fragment RI on RequestInformationPageTemplate {
    url
  }
  fragment SR on PageTemplateSearchResults {
    url
  }
  fragment SM on PageTemplateSiteMap {
    url
  }
  fragment TTC on PageTemplateTuitionCalculator {
    url
  }
`;

export const ILLINKSnippet = `
  ...BA
  ...BC
  ...CSAR
  ...FL
  ...PMER
  ...PDP
  ...OC
  ...RI
  ...SR
  ...SM
  ...TTC
  ...CH
`;


